import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from '@99designs/common/components/Tooltip';
import { Icon } from '@99designs/common/components/Icon';

export default function DesignDetailsTooltip(tooltipId) {
    return (
        <Tooltip
            position="down-center"
            tooltip={
                <div className="tooltip--constrained">
                    <FormattedMessage id={tooltipId} />
                </div>
            }
        >
            <Icon type={'question-mark-2'} variations={['offset-left', 'lighter']} />
        </Tooltip>
    );
}

DesignDetailsTooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/design-details-tooltip.jsx